module.exports = __webpack_public_path__ + "img/1-1.e18cdde0.jpg";